(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/containers/game-launcher-wrapper.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/containers/game-launcher-wrapper.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const PlayAgain = svs.tickets.play.components.PlayAgain;
const BubbleWinMessage = svs.tur.bubbleWinMessage.components.BubbleWinMessage;
const _svs$ticketgames$tick = svs.ticketgames.ticketUtility.components,
  GameLauncherLeia = _svs$ticketgames$tick.GameLauncherLeia,
  GameWrapper = _svs$ticketgames$tick.GameWrapper,
  TopBar = _svs$ticketgames$tick.TopBar,
  Receipt = _svs$ticketgames$tick.Receipt,
  LoaderTicket = _svs$ticketgames$tick.LoaderTicket,
  TicketIdPopper = _svs$ticketgames$tick.TicketIdPopper;
const _svs$ticketgames$tick2 = svs.ticketgames.ticketUtility.utils,
  resizeFromFullscreen = _svs$ticketgames$tick2.resizeFromFullscreen,
  resizeFromTicketInfo = _svs$ticketgames$tick2.resizeFromTicketInfo,
  useDefaultEventsLeiaFactory = _svs$ticketgames$tick2.useDefaultEventsLeiaFactory,
  useScratchDefaultEventsLeiaFactory = _svs$ticketgames$tick2.useScratchDefaultEventsLeiaFactory,
  showDialog = _svs$ticketgames$tick2.showDialog,
  tracking = _svs$ticketgames$tick2.tracking;
const showScratchLaterDialog = svs.ticketgames.ticketUtility.utils.showScratchLaterDialog;
const useCustomEvents = svs.tickets.play.containers.useCustomEvents;
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState,
  useCallback = _React.useCallback,
  useReducer = _React.useReducer,
  useMemo = _React.useMemo;
const Button = svs.ui.ReactButton;
const BottomSheet = svs.tickets.next.components.bottomsheet.BottomSheet;
const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_GAME_REF':
      return _objectSpread(_objectSpread({}, state), {}, {
        gameRef: action.payload
      });
    case 'SET_BET_ID':
      return _objectSpread(_objectSpread({}, state), {}, {
        betId: action.payload
      });
    default:
      return state;
  }
};
const GameLauncherWrapper = _ref => {
  var _ticketInfo$skins;
  let appTimeline = _ref.appTimeline,
    isDemo = _ref.demo,
    hasUnscratchedTicket = _ref.hasUnscratchedTicket,
    history = _ref.history,
    onClose = _ref.onClose,
    skinId = _ref.skinId,
    ticketInfo = _ref.ticketInfo,
    ticketNumber = _ref.ticketNumber,
    wager = _ref.wager,
    wagerId = _ref.wagerId,
    gameIsCompleted = _ref.gameIsCompleted,
    listener = _ref.listener,
    _ref$test = _ref.test,
    test = _ref$test === void 0 ? false : _ref$test;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    fullScreenMargin = _useState2[0],
    setFullScreenMargin = _useState2[1];
  const _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    wrapperSize = _useState4[0],
    setWrapperSize = _useState4[1];
  const isFullScreenGame = ticketInfo.width === 0 && ticketInfo.height === 0;
  const betId = wagerId && parseInt(wagerId, 10);
  const _useReducer = useReducer(reducer, {
      isDemo,
      ticketInfo,
      wager,
      betId,
      isFullScreenGame
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  const contextValue = useMemo(() => _objectSpread(_objectSpread({}, state), {}, {
    dispatch
  }), [state, dispatch]);
  useDefaultEventsLeiaFactory({
    ticketInfo,
    isDemo,
    isReplay: gameIsCompleted,
    wagerId,
    onClose
  });
  const _useCustomEvents = useCustomEvents({
      appTimeline,
      ticketInfo,
      isDemo,
      history,
      hasUnscratchedTicket,
      dispatch
    }),
    onPlayAgain = _useCustomEvents.onPlayAgain;
  const _useScratchDefaultEve = useScratchDefaultEventsLeiaFactory({
      demo: isDemo,
      ticketInfo,
      isFullScreenGame,
      gameIsCompleted,
      onPlayAgain,
      hasUnscratchedTicket,
      onClose,
      test
    }),
    isLoading = _useScratchDefaultEve.isLoading,
    gameResult = _useScratchDefaultEve.gameResult,
    setShouldShowPlayAgainFooter = _useScratchDefaultEve.setShouldShowPlayAgainFooter,
    shouldShowPlayAgainFooter = _useScratchDefaultEve.shouldShowPlayAgainFooter,
    shouldShowBubbleWinMessage = _useScratchDefaultEve.shouldShowBubbleWinMessage,
    soundStatus = _useScratchDefaultEve.soundStatus,
    notifySoundStatus = _useScratchDefaultEve.notifySoundStatus,
    wonTicketId = _useScratchDefaultEve.wonTicketId;
  const shouldShowReceipt = gameIsCompleted && !isLoading;
  const onResizeFunc = isFullScreenGame ? resizeFromFullscreen : resizeFromTicketInfo;
  useEffect(() => {
    const init = async () => {
      const product = ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.branding;
      const extraParams = {
        amount: ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.price,
        product,
        branding: product
      };
      if (!svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER) && !isDemo) {
        svs.components.customer_login.login({
          returnNewCustomer: true,
          extraParams
        });
      } else {
        var _svs, _svs$setupExtraData;
        await ((_svs = svs) === null || _svs === void 0 || (_svs = _svs.accountservices) === null || _svs === void 0 || (_svs = _svs.onboardingHandler) === null || _svs === void 0 || (_svs$setupExtraData = _svs.setupExtraData) === null || _svs$setupExtraData === void 0 ? void 0 : _svs$setupExtraData.call(_svs, {
          extraData: extraParams
        }));
      }
      svs.tickets.play.utils.utils.hideFooter();
    };
    init();
    return () => {
      setTimeout(() => {
        var _appTimeline$isActive;
        if (!(appTimeline !== null && appTimeline !== void 0 && (_appTimeline$isActive = appTimeline.isActive) !== null && _appTimeline$isActive !== void 0 && _appTimeline$isActive.call(appTimeline))) {
          var _appTimeline$pause, _appTimeline$seek;
          appTimeline === null || appTimeline === void 0 || (_appTimeline$pause = appTimeline.pause) === null || _appTimeline$pause === void 0 || _appTimeline$pause.call(appTimeline);
          appTimeline === null || appTimeline === void 0 || (_appTimeline$seek = appTimeline.seek) === null || _appTimeline$seek === void 0 || _appTimeline$seek.call(appTimeline, 'gameReady');
        }
      }, 0);
      svs.tickets.play.utils.utils.showFooter();
      svs.tickets.play.utils.utils.showHeaders(true);
    };
  }, []);
  const onResize = useCallback(container => {
    const size = onResizeFunc(container, ticketInfo);
    if (isFullScreenGame) {
      setFullScreenMargin(size === null || size === void 0 ? void 0 : size.isMinHeight);
    } else {
      setWrapperSize(size);
    }
  }, []);
  const bubbleWinOptions = _objectSpread({
    demo: isDemo,
    product: ticketInfo.type
  }, gameResult);
  const topBarTrackingLabel = tracking.createTopBarTrackingLabel({
    isDemo,
    location: wager ? 'mina-spel' : 'spela',
    gameCode: ticketInfo.type
  });
  const wrapperStyles = isFullScreenGame && fullScreenMargin ? {
    padding: '24px'
  } : _objectSpread(_objectSpread({}, wrapperSize), {}, {
    margin: 'auto'
  });
  const hasTicketNumber = Boolean(ticketNumber && typeof parseInt(ticketNumber, 10) === 'number' && ticketNumber < 32);
  const gameSpecificParameters = {
    skinId: !(ticketInfo !== null && ticketInfo !== void 0 && ticketInfo.defaultSkin) && skinId ? skinId : 1
  };
  const onDialogClose = () => {
    if (svs.tickets.data.validateTicket && !isDemo) {
      var _svs$tickets$data$val;
      tracking.trackValidateQualtrics({
        numberOfTicketsPurchased: 1,
        winAmountValidatedTicket: (_svs$tickets$data$val = svs.tickets.data.validateTicket) === null || _svs$tickets$data$val === void 0 ? void 0 : _svs$tickets$data$val.winAmount,
        winAmountNewTicket: (gameResult === null || gameResult === void 0 ? void 0 : gameResult.extraicon) || (gameResult === null || gameResult === void 0 ? void 0 : gameResult.amount)
      });
    }
    onClose();
  };
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "js-game-launcher-wrapper ".concat(gameResult ? 'game-complete ' : '').concat(isFullScreenGame ? '' : "padding-top-2".concat(!wager ? ' padding-bottom-2' : ''))
  }, shouldShowBubbleWinMessage && !isFullScreenGame && React.createElement("div", {
    className: "qa-win-message-container game-header relative"
  }, React.createElement(BubbleWinMessage, {
    options: bubbleWinOptions
  })), React.createElement(GameWrapper, {
    className: "".concat(isFullScreenGame ? '' : 'ticket-shadow'),
    context: contextValue,
    styles: wrapperStyles
  }, React.createElement(TopBar, {
    isSoundOn: soundStatus,
    onClose: () => {
      var _gameResult$amount;
      showDialog({
        type: 'close',
        isDemo,
        onClose: onDialogClose,
        trackingData: {
          label: topBarTrackingLabel,
          value: (_gameResult$amount = gameResult === null || gameResult === void 0 ? void 0 : gameResult.amount) !== null && _gameResult$amount !== void 0 ? _gameResult$amount : -1
        }
      });
    },
    onSoundClick: () => {
      notifySoundStatus(!soundStatus);
    },
    trackingLabel: topBarTrackingLabel
  }), React.createElement(GameLauncherLeia, {
    className: "relative",
    gameSpecificParameters: gameSpecificParameters,
    listener: listener,
    onResize: onResize
  }, !isLoading && React.createElement(TicketIdPopper, {
    hasTicketNumber: hasTicketNumber
  }), isLoading && React.createElement(LoaderTicket, {
    image: !isFullScreenGame && ((_ticketInfo$skins = ticketInfo.skins[skinId - 1]) === null || _ticketInfo$skins === void 0 ? void 0 : _ticketInfo$skins.image)
  }), !isLoading && hasTicketNumber && React.createElement("div", {
    className: "ticket-number absolute"
  }, ticketNumber))), React.createElement(Receipt, {
    fetchedGame: wager,
    show: shouldShowReceipt,
    ticketInfo: ticketInfo
  })), wonTicketId && !shouldShowPlayAgainFooter && React.createElement(BottomSheet, {
    className: "won-ticket-bottomsheet",
    title: "Vad vill du g\xF6ra nu?"
  }, React.createElement("div", {
    className: "padding-h-2 padding-top-1"
  }, React.createElement("p", {
    className: "margin-bottom-2"
  }, "Du kan skrapa din nya Triss nu p\xE5 en g\xE5ng."), React.createElement("p", {
    className: "margin-bottom-2"
  }, "Vill du hellre dra ut p\xE5 sp\xE4nningen lite? D\xE5 kan du v\xE4lja att skrapa lotten senare."), React.createElement(Button, {
    block: true,
    className: "margin-bottom-1 qa-scratch-now",
    inverted: true,
    onClick: () => {
      svs.utils.url.navigate(svs.core.urlMapping.get('triss_BetDetail').replace(':wagerId', wonTicketId));
    }
  }, "Skrapa din Triss"), React.createElement(Button, {
    block: true,
    className: "margin-bottom-2 qa-scratch-later",
    onClick: () => {
      showScratchLaterDialog({
        onClose: () => {
          setShouldShowPlayAgainFooter(true);
        }
      });
    },
    transparent: true
  }, "Skrapa senare"))), shouldShowPlayAgainFooter && React.createElement(PlayAgain, {
    handlePlayAgain: onPlayAgain,
    hasUnscratchedTicket: hasUnscratchedTicket,
    ticketInfo: ticketInfo
  }));
};
setGlobal('svs.tickets.play.containers.GameLauncherWrapper', GameLauncherWrapper);

 })(window);